
/**
 * 자료 유형
 */
export type EduAssetSummaryAssetType = typeof EduAssetSummaryAssetType[keyof typeof EduAssetSummaryAssetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EduAssetSummaryAssetType = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  MARKDOWN: 'MARKDOWN',
  PDF: 'PDF',
  ZIP: 'ZIP',
  PRESENTATION: 'PRESENTATION',
  SPREADSHEET: 'SPREADSHEET',
  OTHER_ASSET: 'OTHER_ASSET',
} as const;
